import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const CRUST = "#c98a44";
const CRUMB = "#e0ad65";

function loafUnit(cx: number, cy: number, cz: number, s: number): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(s, 0), color: CRUST, position: [cx, cy, cz], scale: [1.5, 0.78, 0.95] as const },
    { geometry: new THREE.BoxGeometry(s * 0.4, 0.01, s * 1.1), color: CRUMB, position: [cx, cy + s * 0.5, cz], rotation: [0, 0, 0.2] },
  ];
}

export const breadLoaf = defineModel({
  id: "bread-loaf",
  batchId: "characters",
  name: "Bread loaf",
  tags: ["good", "cargo", "food"],
  fits: ["carry"],
  summary: "A stack of baked loaves -- a carriable good for an avatar's carry socket.",
  description:
    "Three baked bread loaves at held scale, ported from age-of-mcp's goods " +
    "(`bread`). Mount it in a player's or worker's `carry` socket to show the " +
    "figure hauling bread.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: (): Part[] => [
    ...loafUnit(-0.03, 0.04, 0.0, 0.04),
    ...loafUnit(0.04, 0.04, 0.01, 0.04),
    ...loafUnit(0.0, 0.075, -0.01, 0.038),
  ],
  animations: [],
});
